export default __webpack_public_path__ + "static/media/badge6-2.796eb998.png";